import { SectionProps, useModal } from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback } from 'react'

import { getPolicyVersion } from '../../../domain'
import { ExcessData, usePolicyExcessAdjustment } from '../../../hooks/adjustments/policy'
import { useIsMtaAllowed } from '../../../hooks/adjustments/policy/renewal'
import { usePolicyExcessConfig } from '../../../hooks/excess'
import { usePrincipal } from '../../authentication'
import { AdjustmentModal } from '../../product/policy/adjustments/admin'
import { usePolicy } from '../../product/policy/PolicyProvider'
import { ExcessSection, VoluntaryExcessModal } from '../excess'
import { InRenewalMtaBlockedModal } from '../InRenewalMtaBlockedModal'

export const PolicyExcessSection: FunctionComponent<SectionProps> = (props) => {
  const modal = useModal()
  const { isAdmin } = usePrincipal()
  const { policy } = usePolicy()
  const isMtaAllowed = useIsMtaAllowed()
  const excessConfig = usePolicyExcessConfig()

  const { quote } = getPolicyVersion(policy)

  const isAdjustable = excessConfig?.isAdjustable || isAdmin

  const onEditExcess = useCallback(
    (data: ExcessData) => {
      isMtaAllowed
        ? modal.show({
            content: <PolicyVoluntaryExcessModal data={data} onComplete={modal.hide} />,
          })
        : modal.show({
            content: <InRenewalMtaBlockedModal />,
          })
    },
    [isMtaAllowed, modal],
  )

  return (
    <ExcessSection
      config={excessConfig}
      currentQuote={quote}
      onChange={isAdjustable ? onEditExcess : undefined}
      {...props}
    />
  )
}

const PolicyVoluntaryExcessModal: FunctionComponent<{
  data: ExcessData
  onComplete: () => void
}> = ({ data, onComplete }) => {
  const onSubmitAdjustment = usePolicyExcessAdjustment(onComplete)
  const { isAdmin } = usePrincipal()
  const modal = useModal()
  const { policy } = usePolicy()
  const { quote } = policy.currentPolicyVersion

  const onChange = useCallback(
    (data: ExcessData) => {
      if (isAdmin) {
        modal.show({
          content: (
            <AdjustmentModal
              updatedData={data}
              policy={policy}
              onCancel={modal.hide}
              onSubmitAdjustment={onSubmitAdjustment}
            />
          ),
        })
      } else {
        void onSubmitAdjustment.execute(data)
      }
    },
    [isAdmin, modal, onSubmitAdjustment, policy],
  )

  return (
    <VoluntaryExcessModal
      data={data}
      loading={onSubmitAdjustment.loading}
      onChange={onChange}
      quote={quote}
    />
  )
}
